<div *ngFor="let session of sessionList">
  <vnm-session-date [session]="session"></vnm-session-date>
  <vnm-il-session-location
    *ngIf="showLocation && session.ilLocation"
    [location]="session.ilLocation"
    [hideLocationUrl]="hideLocationUrl"
    class="session-location"
  ></vnm-il-session-location>
</div>
<span *ngIf="!hasSessions" translate>il-class-sessions-cell.no-sessions</span>
